(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .config(route)
    .controller('PatrimoineWizardContractsCategories', PatrimoineWizardContractsCategories)
    .controller('PatrimoineWizardControlTypes', PatrimoineWizardControlTypes)
    .controller('PatrimoineWizardPurchaseModes', PatrimoineWizardPurchaseModes);


    function route($routeProvider) {
        $routeProvider.when('/patrimoine/wizard', {
            templateUrl: 'partials/patrimoine/wizard_view.html',
            controller: 'OpenbaseWizardController',
            reloadOnSearch: false
        });
        $routeProvider.when('/patrimoine/control_type/table_view', {
            templateUrl: 'partials/patrimoine/control_types_table_view.html',
            controller: 'PatrimoineWizardControlTypes',
            reloadOnSearch: false
        });
    }


    function PatrimoineWizardContractsCategories($scope, swif, $http, $q, openbaseWizardService) {
        'ngInject';
        var wizard = openbaseWizardService;
        $scope.contentType = 'patrimoine_contract_type';
        $scope.heads = 'Nom,Code';
        $scope.items = {};
        $scope.loading = {import: {}};
        //fields of the object
        $scope.fields = ['name', 'code'];
        //fields for import params
        var fields = ['name', 'code'];
        wizard.load_json($scope.items, 'json/wizard_contract_categories.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = wizard.pre_import_data($scope.items.selected, $scope.fields);
            wizard.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }


    function PatrimoineWizardControlTypes($scope, swif, $http, $q, openbaseWizardService) {
        'ngInject';
        var wizard = openbaseWizardService;
        $scope.contentType = 'patrimoine_control_type';
        $scope.heads = 'Official,Nom,Description,Law description,Site categories,Property categories,Recurrence';
        $scope.items = {};
        $scope.loading = {import: {}};
        //fields of the object
        $scope.fields = ['is_official', 'name', 'description', 'law_description', 'site_categ_ids', 'site_property_categ_ids', 'recur_type'];
        //fields for import params
        var fields = ['is_official', 'name', 'description', 'law_description', 'site_categ_ids/.id', 'site_property_categ_ids/.id', 'recur_type'];
        wizard.load_json($scope.items, 'json/wizard_control_types.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = wizard.pre_import_data($scope.items.selected, $scope.fields);
            wizard.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }


    function PatrimoineWizardPurchaseModes($scope, swif, $http, $q, openbaseWizardService) {
        'ngInject';
        var wizard = openbaseWizardService;
        $scope.contentType = 'patrimoine_purchase_mode';
        $scope.heads = 'Nom';
        $scope.items = {};
        $scope.loading = {import: {}};
        //fields of the object
        $scope.fields = ['name'];
        //fields for import params
        var fields = ['name'];
        wizard.load_json($scope.items, 'json/wizard_purchase_modes.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = wizard.pre_import_data($scope.items.selected, $scope.fields);
            wizard.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }

})();
